import { Link } from "react-router-dom";
import { SITE } from "@/lib/site";
import { BLOG_PATH } from "@/lib/blogConfig";
import { ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-ink text-white pt-24 pb-12 grain overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          {/* Big call to action */}
          <div className="md:col-span-7">
            <p className="overline text-brass">Let's Talk</p>
            <h2 className="mt-4 font-display text-brass text-5xl sm:text-6xl md:text-7xl tracking-tight leading-[1.02]">
              Florida's Emerald Coast
              <br />
              <span className="italic text-white">starts here.</span>
            </h2>
            <div className="mt-10 flex flex-wrap gap-4">
              <a
                href={SITE.mortgageApplyUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-apply-btn"
                className="inline-flex items-center gap-2 bg-brass text-ink px-7 py-4 rounded-full text-sm font-semibold tracking-wide hover:bg-white transition-colors"
              >
                Apply for a Mortgage
                <ArrowUpRight className="w-4 h-4" />
              </a>
              <a
                href={SITE.phoneHref}
                data-testid="footer-call-btn"
                className="inline-flex items-center gap-2 border border-white/30 text-white px-7 py-4 rounded-full text-sm font-medium hover:bg-white hover:text-ink transition-colors"
              >
                Call {SITE.phone}
              </a>
            </div>
          </div>

          {/* Contact */}
          <div className="md:col-span-5 grid grid-cols-1 sm:grid-cols-2 gap-8 md:pl-8">
            <div>
              <p className="overline text-white/50">Realtor</p>
              <div className="mt-3 flex items-center gap-3">
                <div className="w-12 h-12 rounded-md bg-white inline-flex items-center justify-center p-1.5 flex-shrink-0">
                  <img
                    src={SITE.logos.coastalRealty}
                    alt={`${SITE.affiliations.realty} logo`}
                    className="max-w-full max-h-full object-contain"
                  />
                </div>
                <p className="font-display text-white text-lg leading-tight">
                  {SITE.affiliations.realty}
                </p>
              </div>
              <a
                href={`mailto:${SITE.emails.realty}`}
                data-testid="footer-email-realty"
                className="block mt-3 text-white/80 text-sm hover:text-brass break-all"
              >
                {SITE.emails.realty}
              </a>
            </div>
            <div>
              <p className="overline text-white/50">Mortgage</p>
              <div className="mt-3 flex items-center gap-3">
                <div className="w-12 h-12 rounded-md bg-white inline-flex items-center justify-center p-1.5 flex-shrink-0">
                  <img
                    src={SITE.logos.edgeHomeFinance}
                    alt={`${SITE.affiliations.mortgage} logo`}
                    className="max-w-full max-h-full object-contain"
                  />
                </div>
                <p className="font-display text-white text-lg leading-tight">
                  {SITE.affiliations.mortgage}
                </p>
              </div>
              <a
                href={`mailto:${SITE.emails.mortgage}`}
                data-testid="footer-email-mortgage"
                className="block mt-3 text-white/80 text-sm hover:text-brass break-all"
              >
                {SITE.emails.mortgage}
              </a>
            </div>
            <div className="sm:col-span-2">
              <p className="overline text-white/50">Direct</p>
              <a
                href={SITE.phoneHref}
                data-testid="footer-phone"
                className="block mt-2 font-display text-white text-2xl hover:text-brass"
              >
                {SITE.phone}
              </a>
              <p className="mt-2 text-white/60 text-sm">
                Real Estate · Okaloosa, Walton & Santa Rosa Counties, FL
                <br />
                Mortgage · All 50 U.S. states
              </p>
            </div>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-white/50">
          <p>
            © {new Date().getFullYear()} {SITE.fullName}. Realtor with{" "}
            {SITE.affiliations.realty}. Mortgage Advisor with {SITE.affiliations.mortgage}.
          </p>
          <nav
            data-testid="footer-secondary-nav"
            className="flex items-center gap-5 text-white/60"
          >
            <Link
              to={BLOG_PATH}
              data-testid="footer-blog-link"
              className="hover:text-brass transition-colors"
            >
              Blog
            </Link>
            <Link
              to="/faq"
              data-testid="footer-faq-link"
              className="hover:text-brass transition-colors"
            >
              Q&amp;A
            </Link>
            <Link
              to="/admin/login"
              data-testid="footer-admin-link"
              className="text-white/30 hover:text-white/70 transition-colors"
            >
              Admin
            </Link>
          </nav>
          <p className="md:text-right">
            {SITE.licenses.realEstate} · {SITE.licenses.nmls}
            <br />
            Equal Housing Opportunity · Licensed in Florida
          </p>
        </div>
      </div>
    </footer>
  );
}
